module.exports = __webpack_public_path__ + "static/media/hourglass_rainbow_fulldba976dc0689f72f658355a9890ae529.webp";